<template>
  <input style="opacity: 0; position: absolute" type="text" name="email" />
  <input
    style="opacity: 0; position: absolute"
    type="password"
    name="password"
  />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'DisableAutocomplete'
})
export default class DisableAutocompleteComponent extends Vue {}
</script>
